import { render, staticRenderFns } from "./depositShopCRUD.vue?vue&type=template&id=2b32104e&scoped=true&"
import script from "./depositShopCRUD.vue?vue&type=script&lang=js&"
export * from "./depositShopCRUD.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b32104e",
  null
  
)

export default component.exports